import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import T from '../../i18n/i18n';
import TurnOrderListing from './TurnOrderListing/TurnOrderListing';
import TurnOrderForm from './TurnOrderForm/TurnOrderForm';
import TurnOrderConfig from './TurnOrderConfig/TurnOrderConfig';
import TurnOrderCarousel from './TurnOrderCarousel/TurnOrderCarousel';
import { Container, Header, MainHeader, SideHeader, Content, Carousel, Listing, ButtonCarousel, SideHeaderTitle, SideHeaderValue } from './TurnOrder.styles';
import { turnorderActions, rtcBufferActions } from '../../../redux/actions';
import {listTurnOrder, addTurnOrder, editTurnOrder, removeTurnOrder, moveTurnOrder, prevTurnOrder, nextTurnOrder, orderAscTurnOrder, orderDescTurnOrder, clearTurnOrder} from '../../../services/turnorder';
import { Store } from '../../../redux/stores';

const syncTurnOrder = (turnorder) => {
    Store.dispatch(rtcBufferActions.pushOutputBuffer({
        type: 'turnOrderSync',
        data: {turnOrders: turnorder}
    }));
}

const groupProcessed = {};
const insertTurn = async (tableId, newItem) => {
    if (groupProcessed[newItem.groupId]) {
        return;
    }

    groupProcessed[newItem.groupId] = true;

    let turns = await addTurnOrder(tableId, newItem.name, newItem.value, newItem.token);

    if (turns && turns.turnOrder) {
        Store.dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
        Store.dispatch(turnorderActions.setTurns(turns.currentTurn));
        syncTurnOrder(turns.turnOrder);
    }
}

export default ({tableId}) => {

    const opened = useSelector(state => state.turnorderState.opened);
    const openedTimers = useSelector(state => state.timersState.opened);
    const currentTurn = useSelector(state => state.turnorderState.currentTurn);
    const isOwner = useSelector(state => state.authState.isOwner);
    const [formStep, setFormStep] = useState('list');
    const [loadItem, setLoadItem] = useState(null);

    const messages = useSelector(state => state.chatState.messages);

    const dispatch = useDispatch();

    const handleOpenAdd = () => {
        if (!isOwner) {
            return;
        }

        setLoadItem(null);
        setFormStep('form');
    }

    const handleOpenEdit = (item) => {
        if (!isOwner) {
            return;
        }

        setLoadItem(item);
        setFormStep('form');
    }

    const handleSave = async (newItem, loadedItem) => {
        if (!isOwner) {
            return;
        }

        if (!loadedItem) {
            await insertTurn(tableId, newItem);
            setLoadItem(null);
        } else {
            let turns = await editTurnOrder(tableId, loadedItem.id, newItem.name, newItem.value, newItem.token);
            setLoadItem({
                id: loadedItem.id, 
                name: newItem.name, 
                value: newItem.value, 
                token: newItem.token
            });

            if (turns && turns.turnOrder) {
                dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
                dispatch(turnorderActions.setTurns(turns.currentTurn));
                syncTurnOrder(turns.turnOrder);
            }
        }

        setFormStep('list');
    }

    const handleRemove = async (item) => {
        if (!isOwner) {
            return;
        }

        const turns = await removeTurnOrder(tableId, item.id);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }
        setLoadItem(null);
        setFormStep('list');
    }

    const handlePrev = async () => {
        if (!isOwner) {
            return;
        }

        const turns = await prevTurnOrder(tableId);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }
    }

    const handleNext = async () => {
        if (!isOwner) {
            return;
        }

        const turns = await nextTurnOrder(tableId);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }
    }

    const handleMove = async (item, direction) => {
        if (!isOwner) {
            return;
        }

        const turns = await moveTurnOrder(tableId, item.id, direction);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }
    }

    const handleOrderAsc = async () => {
        if (!isOwner) {
            return;
        }

        const turns = await orderAscTurnOrder(tableId);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }

        setLoadItem(null);
        setFormStep('list');
    }

    const handleOrderDesc = async () => {
        if (!isOwner) {
            return;
        }

        const turns = await orderDescTurnOrder(tableId);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }

        setLoadItem(null);
        setFormStep('list');
    }

    const handleClear = async () => {
        if (!isOwner) {
            return;
        }

        const turns = await clearTurnOrder(tableId);

        if (turns && turns.turnOrder) {
            dispatch(turnorderActions.setTurnOrders(turns.turnOrder));
            dispatch(turnorderActions.setTurns(turns.currentTurn));
            syncTurnOrder(turns.turnOrder);
        }

        setLoadItem(null);
        setFormStep('list');
    }

    const handleBackListing = () => {
        setLoadItem(null);
        setFormStep('list');
    }

    const handleOpenConfig = () => {
        if (!isOwner) {
            return;
        }

        setFormStep('config');
    }


    useEffect(() => {
        let lastMessage = messages[messages.length - 1];
        if (lastMessage && isOwner) {
            if (lastMessage.messages && lastMessage.messages.length) {
                let cmdItem = [...lastMessage.messages].reverse().find(i=>i.command === 'addturn');
                if (cmdItem) {
                    insertTurn(tableId, {
                        name: cmdItem.content[0] ?? '',
                        value: cmdItem.content[1] ?? '0',
                        token: cmdItem.content[2] ?? '',
                        groupId: cmdItem.content[3] ?? ''
                    });
                }
            }
        }
    }, [tableId, messages, isOwner]);

    useEffect(() => {
        (async () => {
            const turnOrders = await listTurnOrder(tableId);

            if (turnOrders && turnOrders.turnOrder) {
                dispatch(turnorderActions.setTurnOrders(turnOrders.turnOrder));
                dispatch(turnorderActions.setTurns(turnOrders.currentTurn));
            }
        })();
    }, [dispatch, tableId]);

    
    return <Container className={(opened ? 'opened' : '') + (openedTimers ? ' timerOpened' : '')}>
        <Header>
            <MainHeader><T value='turnorder.title' /></MainHeader>
            <SideHeader>
                <SideHeaderTitle><T value='turnorder.currentTurn' /></SideHeaderTitle>
                <SideHeaderValue>{currentTurn}</SideHeaderValue>
            </SideHeader>
        </Header>
        <Content>
            <Carousel>
                { isOwner ? <ButtonCarousel icon="\F004D" onClick={handlePrev} /> : null }
                <TurnOrderCarousel />
                { isOwner ? <ButtonCarousel icon="\F0054" onClick={handleNext} /> : null }
            </Carousel>
            <Listing>
                <TurnOrderListing
                    value={loadItem}
                    onClickAdd={handleOpenAdd}
                    onClickEdit={handleOpenEdit}
                    onClickRemove={handleRemove}
                    onClickConfig={handleOpenConfig}
                    onClickMoveUp={(item)=>handleMove(item, 'up')}
                    onClickMoveDown={(item)=>handleMove(item, 'down')}
                />
                <TurnOrderForm
                    className={formStep === 'form' && isOwner ? 'active' : ''}
                    value={loadItem}
                    onClickBack={handleBackListing}
                    onClickSave={handleSave}
                />
                <TurnOrderConfig
                    className={formStep === 'config' && isOwner ? 'active' : ''}
                    onClickOrderAsc={handleOrderAsc}
                    onClickOrderDesc={handleOrderDesc}
                    onClickClear={handleClear}
                    onClickBack={handleBackListing}
                />
                
            </Listing>
        </Content>
    </Container>
}